import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Task 구성하기",
  "description": "리포지토리의 워크플로우를 최대한 빠르게 실행하기 위해 설명하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Task는 Turborepo가 실행하는 스크립트입니다. turbo.json 구성과 Package Graph에서 task 간의 관계를 표현할 수 있습니다."
  }, {
    "heading": "",
    "content": "Turborepo는 모든 것이 최대한 빠르게 실행되도록 가능한 모든 작업을 병렬화합니다. 이는 task를 하나씩 실행하는 것보다 빠르며, Turborepo를 빠르게 만드는 요소 중 하나입니다."
  }, {
    "heading": "",
    "content": "예를 들어, yarn workspaces run lint && yarn workspaces run build && yarn workspaces run test는 다음과 같습니다:"
  }, {
    "heading": "",
    "content": "하지만 Turborepo로 동일한 작업을 더 빠르게 완료하려면 turbo run lint build test를 사용할 수 있습니다:"
  }, {
    "heading": "시작하기",
    "content": "루트 turbo.json 파일은 Turborepo가 실행할 task를 등록하는 곳입니다. task를 정의하면 turbo run을 사용하여 하나 이상의 task를 실행할 수 있습니다."
  }, {
    "heading": "시작하기",
    "content": "처음부터 시작하는 경우, create-turbo를 사용하여 새 리포지토리 생성하고 turbo.json 파일을 편집하여 이 가이드의 스니펫을 시도해 보는 것을 권장합니다."
  }, {
    "heading": "시작하기",
    "content": "기존 리포지토리에서 Turborepo를 도입하는 경우, 리포지토리 루트에 turbo.json 파일을 생성합니다. 이 가이드의 나머지 구성 옵션에 대해 학습하는 데 사용할 것입니다."
  }, {
    "heading": "task-정의하기",
    "content": "tasks 객체의 각 키는 turbo run으로 실행할 수 있는 task입니다. Turborepo는 task와 동일한 이름을 가진 package.json의 스크립트를 패키지에서 검색합니다."
  }, {
    "heading": "task-정의하기",
    "content": "task를 정의하려면 turbo.json에서 tasks 객체를 사용합니다. 예를 들어, 종속성과 출력이 없는 build라는 기본 task는 다음과 같을 수 있습니다:"
  }, {
    "heading": "task-정의하기",
    "content": "이 시점에서 turbo run build를 실행하면 Turborepo는 패키지의 모든 build 스크립트를 병렬로 실행하며 파일 출력을 캐싱하지 않습니다. 이는 빠르게 오류로 이어집니다. 예상대로 작동하도록 하려면 몇 가지 중요한 부분이 누락되었습니다."
  }, {
    "heading": "올바른-순서로-task-실행하기",
    "content": "dependsOn 키는 다른 task가 실행되기 전에 완료해야 하는 task를 지정하는 데 사용됩니다. 예를 들어, 대부분의 경우 애플리케이션의 build 스크립트가 실행되기 전에 라이브러리의 build 스크립트가 완료되기를 원합니다. 이렇게 하려면 다음 turbo.json을 사용합니다:"
  }, {
    "heading": "올바른-순서로-task-실행하기",
    "content": "이제 종속성을 의존하는 것 이전에 빌드하는 예상한 빌드 순서를 갖게 되었습니다."
  }, {
    "heading": "올바른-순서로-task-실행하기",
    "content": "하지만 주의하세요. 이 시점에서는 캐싱을 위한 빌드 출력을 표시하지 않았습니다. 그렇게 하려면 출력 지정하기 섹션으로 이동하세요."
  }, {
    "heading": "를-사용하여-종속성의-task에-의존하기",
    "content": "^ 마이크로 구문은 Turborepo에 대상 패키지 이전에 직접 종속성의 task를 실행하도록 지시합니다. 애플리케이션이 ui라는 라이브러리에 종속되어 있고 라이브러리에 build task가 있는 경우, ui의 build 스크립트가 먼저 실행됩니다. 성공적으로 완료되면 애플리케이션의 build task가 실행됩니다."
  }, {
    "heading": "를-사용하여-종속성의-task에-의존하기",
    "content": "이는 애플리케이션의 build task가 컴파일하는 데 필요한 모든 필수 종속성을 갖도록 보장하므로 중요한 패턴입니다. 이 개념은 종속성 그래프가 여러 수준의 task 종속성을 가진 더 복잡한 구조로 성장함에 따라 적용됩니다."
  }, {
    "heading": "동일한-패키지의-task에-의존하기",
    "content": "때로는 동일한 패키지의 두 task가 특정 순서로 실행되도록 해야 할 수 있습니다. 예를 들어, 동일한 라이브러리에서 test task를 실행하기 전에 라이브러리의 build task를 실행해야 할 수 있습니다. 이렇게 하려면 dependsOn 키에서 스크립트를 일반 문자열로 지정합니다(^ 없이)."
  }, {
    "heading": "특정-패키지의-특정-task에-의존하기",
    "content": "특정 패키지의 개별 task를 의존하도록 지정할 수도 있습니다. 아래 예제에서는 모든 lint task 전에 utils의 build task를 실행해야 합니다."
  }, {
    "heading": "특정-패키지의-특정-task에-의존하기",
    "content": "의존 task에 대해 더 구체적으로 지정하여 특정 패키지로 제한할 수도 있습니다:"
  }, {
    "heading": "특정-패키지의-특정-task에-의존하기",
    "content": "이 구성을 사용하면 web 패키지의 lint task는 utils 패키지의 build task가 완료된 후에만 실행할 수 있습니다."
  }, {
    "heading": "종속성-없음",
    "content": "일부 task에는 종속성이 없을 수 있습니다. 예를 들어, Markdown 파일에서 오타를 찾는 task는 다른 task의 상태를 신경 쓸 필요가 없을 것입니다. 이 경우 dependsOn 키를 생략하거나 빈 배열을 제공할 수 있습니다."
  }, {
    "heading": "outputs-지정하기",
    "content": "Turborepo는 task의 출력을 캐싱하므로 동일한 작업을 두 번 수행하지 않습니다.\n이에 대해서는 캐싱 가이드에서 자세히\n다루겠지만, 먼저 task가 올바르게 구성되었는지 확인해야 합니다."
  }, {
    "heading": "outputs-지정하기",
    "content": "outputs 키는 task가 성공적으로 완료되었을 때 캐싱해야 하는 파일과 디렉토리를 Turborepo에 알려줍니다. 이 키가 정의되지 않으면 Turborepo는 파일을 캐싱하지 않습니다. 후속 실행에서 캐시를 적중해도 파일 출력을 복원하지 않습니다."
  }, {
    "heading": "outputs-지정하기",
    "content": "다음은 일반적인 도구의 출력 예제입니다:"
  }, {
    "heading": "outputs-지정하기",
    "content": "Glob은 패키지에 상대적이므로 dist/**는 각 패키지에 대해 출력되는 dist를 각각 처리합니다. outputs 키에 대한 globbing 패턴 구축에 대한 자세한 내용은 globbing 사양을 참조하세요."
  }, {
    "heading": "inputs-지정하기",
    "content": "inputs 키는 캐싱을 위해 task의 해시에 포함하려는 파일을 지정하는 데 사용됩니다. 기본적으로 Turborepo는 Git에서 추적하는 패키지의 모든 파일을 포함합니다. 그러나 inputs 키를 사용하여 해시에 포함할 파일을 더 구체적으로 지정할 수 있습니다."
  }, {
    "heading": "inputs-지정하기",
    "content": "예를 들어, Markdown 파일에서 오타를 찾는 task는 다음과 같이 정의할 수 있습니다:"
  }, {
    "heading": "inputs-지정하기",
    "content": "이제 Markdown 파일의 변경 사항만 spell-check task가 캐시를 미스하게 합니다."
  }, {
    "heading": "inputs-지정하기",
    "content": "이 기능은 소스 제어에서 추적하는 변경 사항을 따르는 것을 포함하여 Turborepo의 모든 기본 inputs 동작을 거부합니다. 이는 .gitignore 파일이 더 이상 존중되지 않으며, glob으로 해당 파일을 캡처하지 않도록 해야 함을 의미합니다."
  }, {
    "heading": "inputs-지정하기",
    "content": "기본 동작을 복원하려면 $TURBO_DEFAULT$ 마이크로 구문을 사용하세요."
  }, {
    "heading": "turbo_default로-기본값-복원하기",
    "content": "기본 inputs 동작은 종종 task에 원하는 것입니다. 그러나 task 출력에 영향을 주지 않는 것으로 알려진 파일의 변경 사항을 무시하도록 inputs를 미세 조정하여 특정 task의 캐시 적중률을 높일 수 있습니다."
  }, {
    "heading": "turbo_default로-기본값-복원하기",
    "content": "이러한 이유로 $TURBO_DEFAULT$ 마이크로 구문을 사용하여 기본 inputs 동작을 미세 조정할 수 있습니다:"
  }, {
    "heading": "turbo_default로-기본값-복원하기",
    "content": "이 task 정의에서 Turborepo는 build task에 대해 기본 inputs 동작을 사용하지만 README.md 파일의 변경 사항은 무시합니다. README.md 파일이 변경되어도 task는 여전히 캐시를 적중합니다."
  }, {
    "heading": "root-task-등록하기",
    "content": "turbo를 사용하여 Workspace 루트의 package.json에서 스크립트를 실행할 수도 있습니다. 예를 들어, 각 패키지의 lint task 외에도 Workspace 루트 디렉토리의 파일에 대한 lint:root task를 실행할 수 있습니다:"
  }, {
    "heading": "root-task-등록하기",
    "content": "Root Task가 등록되면 turbo run lint:root가 task를 실행합니다. 또한 turbo run lint lint:root를 실행하여 모든 린팅 task를 실행할 수 있습니다."
  }, {
    "heading": "root-task를-사용하는-경우",
    "content": "Workspace 루트의 린팅 및 포맷팅: Workspace 루트에 린팅 및 포맷팅하려는 코드가 있을 수 있습니다. 예를 들어, 루트 디렉토리에서 ESLint 또는 Prettier를 실행할 수 있습니다."
  }, {
    "heading": "root-task를-사용하는-경우",
    "content": "점진적 마이그레이션: Turborepo로 마이그레이션하는 동안 아직 패키지로 이동하지 않은 일부 스크립트가 있는 중간 단계가 있을 수 있습니다. 이 경우 Root Task를 생성하여 마이그레이션을 시작하고 나중에 task를 패키지로 분산할 수 있습니다."
  }, {
    "heading": "root-task를-사용하는-경우",
    "content": "패키지 범위가 없는 스크립트: 특정 패키지의 컨텍스트에서 의미가 없는 일부 스크립트가 있을 수 있습니다. 이러한 스크립트는 Root Task로 등록할 수 있으므로 캐싱, 병렬화 및 워크플로우 목적으로 여전히 turbo로 실행할 수 있습니다."
  }, {
    "heading": "package-configuration-사용하기",
    "content": "Package Configuration은 패키지에 직접 배치되는 turbo.json 파일입니다. 이를 통해 패키지는 리포지토리의 나머지 부분에 영향을 주지 않고 자체 task에 대한 특정 동작을 정의할 수 있습니다."
  }, {
    "heading": "package-configuration-사용하기",
    "content": "많은 팀이 있는 대규모 monorepo에서는 팀이 자체 task에 대해 더 큰 제어권을 갖습니다. 자세한 내용은 Package Configuration 문서를 참조하세요."
  }, {
    "heading": "런타임-종속성이-있는-장기-실행-task",
    "content": "동시에 항상 실행되어야 하는 다른 task가 필요한 장기 실행 task가 있을 수 있습니다. 이를 위해 with 키를 사용합니다."
  }, {
    "heading": "런타임-종속성이-있는-장기-실행-task",
    "content": "장기 실행 task는 종료되지 않으므로 이에 의존할 수 없습니다. 대신 with 키워드는 web#dev task가 실행될 때마다 api#dev task를 실행합니다."
  }, {
    "heading": "부작용-수행하기",
    "content": "캐시된 빌드 후 배포 스크립트와 같이 일부 task는 항상 실행되어야 합니다. 이러한 task의 경우 task 정의에 \"cache\": false를 추가합니다."
  }, {
    "heading": "병렬로-실행할-수-있는-종속-task",
    "content": "일부 task는 다른 패키지에 종속되어 있음에도 불구하고 병렬로 실행할 수 있습니다. 이 설명에 맞는 task의 예는 타입 체커입니다. 타입 체커는 성공적으로 실행하기 위해 종속성의 출력을 기다릴 필요가 없기 때문입니다."
  }, {
    "heading": "병렬로-실행할-수-있는-종속-task",
    "content": "이 때문에 check-types task를 다음과 같이 정의하고 싶을 수 있습니다:"
  }, {
    "heading": "병렬로-실행할-수-있는-종속-task",
    "content": "이렇게 하면 task가 병렬로 실행되지만 종속성의 소스 코드 변경 사항을 고려하지 않습니다. 이는 다음을 의미합니다:"
  }, {
    "heading": "병렬로-실행할-수-있는-종속-task",
    "content": "ui 패키지의 인터페이스에 중단 변경을 합니다."
  }, {
    "heading": "병렬로-실행할-수-있는-종속-task",
    "content": "turbo check-types를 실행하여 ui에 종속되는 애플리케이션 패키지에서 캐시를 적중합니다."
  }, {
    "heading": "병렬로-실행할-수-있는-종속-task",
    "content": "애플리케이션 패키지가 새 인터페이스를 사용하도록 업데이트되지 않았음에도 불구하고 성공적인 캐시 적중을 표시하므로 이는 올바르지 않습니다. 편집기에서 애플리케이션 패키지의 TypeScript 오류를 수동으로 확인하면 오류가 나타날 것입니다."
  }, {
    "heading": "병렬로-실행할-수-있는-종속-task",
    "content": "이 때문에 check-types task 정의를 약간 변경합니다:"
  }, {
    "heading": "병렬로-실행할-수-있는-종속-task",
    "content": "ui 패키지에서 중단 변경을 다시 테스트하면 캐싱 동작이 이제 올바른 것을 알 수 있습니다. 그러나 task는 더 이상 병렬로 실행되지 않습니다."
  }, {
    "heading": "병렬로-실행할-수-있는-종속-task",
    "content": "두 요구 사항(정확성과 병렬성)을 모두 충족하려면 Task Graph에 Transit Node를 도입할 수 있습니다:"
  }, {
    "heading": "병렬로-실행할-수-있는-종속-task",
    "content": "이러한 Transit Node는 package.json의 스크립트와 일치하지 않아 아무 작업도 수행하지 않는 task를 사용하여 패키지 종속성 간의 관계를 생성합니다. 이 때문에 task는 병렬로 실행되고 내부 종속성의 변경 사항을 인식할 수 있습니다."
  }, {
    "heading": "병렬로-실행할-수-있는-종속-task",
    "content": "이 예제에서는 transit이라는 이름을 사용했지만 Workspace에서 이미 스크립트가\n아닌 이름을 사용할 수 있습니다."
  }, {
    "heading": "다음-단계",
    "content": "향후 가이드에서 탐색할 turbo.json 구성 문서에서 더 많은 옵션을 사용할 수 있습니다. 지금은 기본 작동 방식을 확인하기 위해 몇 가지 task를 실행할 수 있습니다."
  }],
  "headings": [{
    "id": "시작하기",
    "content": "시작하기"
  }, {
    "id": "task-정의하기",
    "content": "Task 정의하기"
  }, {
    "id": "올바른-순서로-task-실행하기",
    "content": "올바른 순서로 task 실행하기"
  }, {
    "id": "를-사용하여-종속성의-task에-의존하기",
    "content": "^를 사용하여 종속성의 task에 의존하기"
  }, {
    "id": "동일한-패키지의-task에-의존하기",
    "content": "동일한 패키지의 task에 의존하기"
  }, {
    "id": "특정-패키지의-특정-task에-의존하기",
    "content": "특정 패키지의 특정 task에 의존하기"
  }, {
    "id": "종속성-없음",
    "content": "종속성 없음"
  }, {
    "id": "outputs-지정하기",
    "content": "outputs 지정하기"
  }, {
    "id": "inputs-지정하기",
    "content": "inputs 지정하기"
  }, {
    "id": "turbo_default로-기본값-복원하기",
    "content": "$TURBO_DEFAULT$로 기본값 복원하기"
  }, {
    "id": "root-task-등록하기",
    "content": "Root Task 등록하기"
  }, {
    "id": "root-task를-사용하는-경우",
    "content": "Root Task를 사용하는 경우"
  }, {
    "id": "고급-사용-사례",
    "content": "고급 사용 사례"
  }, {
    "id": "package-configuration-사용하기",
    "content": "Package Configuration 사용하기"
  }, {
    "id": "런타임-종속성이-있는-장기-실행-task",
    "content": "런타임 종속성이 있는 장기 실행 task"
  }, {
    "id": "부작용-수행하기",
    "content": "부작용 수행하기"
  }, {
    "id": "병렬로-실행할-수-있는-종속-task",
    "content": "병렬로 실행할 수 있는 종속 task"
  }, {
    "id": "다음-단계",
    "content": "다음 단계"
  }]
};
import {LinkToDocumentation} from '#components/link-to-documentation';
import {Callout} from '#components/callout';
import {Tabs, Tab} from '#components/tabs';
import {Files, File, Folder} from '#components/files';
import {ThemeAwareImage} from '#components/theme-aware-image';
export const toc = [{
  depth: 2,
  url: "#시작하기",
  title: _jsx(_Fragment, {
    children: "시작하기"
  })
}, {
  depth: 2,
  url: "#task-정의하기",
  title: _jsx(_Fragment, {
    children: "Task 정의하기"
  })
}, {
  depth: 3,
  url: "#올바른-순서로-task-실행하기",
  title: _jsx(_Fragment, {
    children: "올바른 순서로 task 실행하기"
  })
}, {
  depth: 4,
  url: "#를-사용하여-종속성의-task에-의존하기",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "^"
    }), "를 사용하여 종속성의 task에 의존하기"]
  })
}, {
  depth: 4,
  url: "#동일한-패키지의-task에-의존하기",
  title: _jsx(_Fragment, {
    children: "동일한 패키지의 task에 의존하기"
  })
}, {
  depth: 4,
  url: "#특정-패키지의-특정-task에-의존하기",
  title: _jsx(_Fragment, {
    children: "특정 패키지의 특정 task에 의존하기"
  })
}, {
  depth: 4,
  url: "#종속성-없음",
  title: _jsx(_Fragment, {
    children: "종속성 없음"
  })
}, {
  depth: 3,
  url: "#outputs-지정하기",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "outputs"
    }), " 지정하기"]
  })
}, {
  depth: 3,
  url: "#inputs-지정하기",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "inputs"
    }), " 지정하기"]
  })
}, {
  depth: 4,
  url: "#turbo_default로-기본값-복원하기",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "$TURBO_DEFAULT$"
    }), "로 기본값 복원하기"]
  })
}, {
  depth: 3,
  url: "#root-task-등록하기",
  title: _jsx(_Fragment, {
    children: "Root Task 등록하기"
  })
}, {
  depth: 4,
  url: "#root-task를-사용하는-경우",
  title: _jsx(_Fragment, {
    children: "Root Task를 사용하는 경우"
  })
}, {
  depth: 2,
  url: "#고급-사용-사례",
  title: _jsx(_Fragment, {
    children: "고급 사용 사례"
  })
}, {
  depth: 3,
  url: "#package-configuration-사용하기",
  title: _jsx(_Fragment, {
    children: "Package Configuration 사용하기"
  })
}, {
  depth: 3,
  url: "#런타임-종속성이-있는-장기-실행-task",
  title: _jsx(_Fragment, {
    children: "런타임 종속성이 있는 장기 실행 task"
  })
}, {
  depth: 3,
  url: "#부작용-수행하기",
  title: _jsx(_Fragment, {
    children: "부작용 수행하기"
  })
}, {
  depth: 3,
  url: "#병렬로-실행할-수-있는-종속-task",
  title: _jsx(_Fragment, {
    children: "병렬로 실행할 수 있는 종속 task"
  })
}, {
  depth: 2,
  url: "#다음-단계",
  title: _jsx(_Fragment, {
    children: "다음 단계"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Task는 Turborepo가 실행하는 스크립트입니다. ", _jsxs(_components.a, {
        href: "/docs/reference/configuration",
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), " 구성"]
      }), "과 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), "에서 task 간의 관계를 표현할 수 있습니다."]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 모든 것이 최대한 빠르게 실행되도록 가능한 모든 작업을 병렬화합니다. 이는 task를 하나씩 실행하는 것보다 빠르며, Turborepo를 빠르게 만드는 요소 중 하나입니다."
    }), "\n", _jsxs(_components.p, {
      children: ["예를 들어, ", _jsx("code", {
        style: {
          textWrap: "wrap"
        },
        children: "yarn workspaces run lint && yarn workspaces run build && yarn workspaces run test"
      }), "는 다음과 같습니다:"]
    }), "\n", _jsx(ThemeAwareImage, {
      dark: {
        alt: 'A graphical representation of `turbo run lint test build`. It shows all tasks running in parallel, with much less empty space where scripts are not being ran.',
        src: '/images/docs/slow-tasks-dark.png',
        props: {
          width: 778,
          height: 331
        }
      },
      light: {
        alt: 'A graphical representation of `turbo run lint test build`. It shows all tasks running in parallel, with much less empty space where scripts are not being ran.',
        src: '/images/docs/slow-tasks-light.png',
        props: {
          width: 778,
          height: 331
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: ["하지만 Turborepo로 동일한 작업을 ", _jsx(_components.strong, {
        children: "더 빠르게"
      }), " 완료하려면 ", _jsx(_components.code, {
        children: "turbo run lint build test"
      }), "를 사용할 수 있습니다:"]
    }), "\n", _jsx(ThemeAwareImage, {
      dark: {
        alt: 'A graphical representation of `turbo run lint test build`. It shows all tasks running in parallel, with much less empty space where scripts are not being ran.',
        src: '/images/docs/turborepo-tasks-fast-dark.png',
        props: {
          width: 778,
          height: 448
        }
      },
      light: {
        alt: 'A graphical representation of `turbo run lint test build`. It shows all tasks running in parallel, with much less empty space where scripts are not being ran.',
        src: '/images/docs/turborepo-tasks-fast-light.png',
        props: {
          width: 778,
          height: 448
        }
      }
    }), "\n", _jsx(_components.h2, {
      id: "시작하기",
      children: "시작하기"
    }), "\n", _jsxs(_components.p, {
      children: ["루트 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 파일은 Turborepo가 실행할 task를 등록하는 곳입니다. task를 정의하면 ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: _jsx(_components.code, {
          children: "turbo run"
        })
      }), "을 사용하여 하나 이상의 task를 실행할 수 있습니다."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["처음부터 시작하는 경우, ", _jsxs(_components.a, {
          href: "/docs/getting-started/installation",
          children: [_jsx(_components.code, {
            children: "create-turbo"
          }), "를 사용하여 새 리포지토리 생성"]
        }), "하고 ", _jsx(_components.code, {
          children: "turbo.json"
        }), " 파일을 편집하여 이 가이드의 스니펫을 시도해 보는 것을 권장합니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["기존 리포지토리에서 Turborepo를 도입하는 경우, 리포지토리 루트에 ", _jsx(_components.code, {
          children: "turbo.json"
        }), " 파일을 생성합니다. 이 가이드의 나머지 구성 옵션에 대해 학습하는 데 사용할 것입니다."]
      }), "\n"]
    }), "\n", _jsxs(Files, {
      children: [_jsx(File, {
        name: "turbo.json",
        green: true
      }), _jsx(File, {
        name: "package.json"
      }), _jsx(Folder, {
        name: "apps"
      }), _jsx(Folder, {
        name: "packages"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "task-정의하기",
      children: "Task 정의하기"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "tasks"
      }), " 객체의 각 키는 ", _jsx(_components.code, {
        children: "turbo run"
      }), "으로 실행할 수 있는 task입니다. Turborepo는 ", _jsxs(_components.strong, {
        children: ["task와 동일한 이름을 가진 ", _jsx(_components.code, {
          children: "package.json"
        }), "의 스크립트"]
      }), "를 패키지에서 검색합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["task를 정의하려면 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에서 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#tasks",
        children: [_jsx(_components.code, {
          children: "tasks"
        }), " 객체"]
      }), "를 사용합니다. 예를 들어, 종속성과 출력이 없는 ", _jsx(_components.code, {
        children: "build"
      }), "라는 기본 task는 다음과 같을 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {} "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// Incorrect!"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 시점에서 ", _jsx(_components.code, {
        children: "turbo run build"
      }), "를 실행하면 Turborepo는 패키지의 모든 ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트를 병렬로 실행하며 파일 출력을 캐싱하지 않습니다. ", _jsx(_components.strong, {
        children: "이는 빠르게 오류로 이어집니다."
      }), " 예상대로 작동하도록 하려면 몇 가지 중요한 부분이 누락되었습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "올바른-순서로-task-실행하기",
      children: "올바른 순서로 task 실행하기"
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/configuration#dependson",
        children: [_jsx(_components.code, {
          children: "dependsOn"
        }), " 키"]
      }), "는 다른 task가 실행되기 전에 완료해야 하는 task를 지정하는 데 사용됩니다. 예를 들어, 대부분의 경우 애플리케이션의 ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트가 실행되기 전에 라이브러리의 ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트가 완료되기를 원합니다. 이렇게 하려면 다음 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "을 사용합니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이제 ", _jsx(_components.em, {
        children: "종속성"
      }), "을 ", _jsx(_components.em, {
        children: "의존하는 것"
      }), " 이전에 빌드하는 예상한 빌드 순서를 갖게 되었습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "하지만 주의하세요."
      }), " 이 시점에서는 캐싱을 위한 빌드 출력을 표시하지 않았습니다. 그렇게 하려면 ", _jsx(_components.a, {
        href: "#specifying-outputs",
        children: "출력 지정하기"
      }), " 섹션으로 이동하세요."]
    }), "\n", _jsxs(_components.h4, {
      id: "를-사용하여-종속성의-task에-의존하기",
      children: [_jsx(_components.code, {
        children: "^"
      }), "를 사용하여 종속성의 task에 의존하기"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "^"
      }), " 마이크로 구문은 Turborepo에 대상 패키지 이전에 직접 종속성의 task를 실행하도록 지시합니다. 애플리케이션이 ", _jsx(_components.code, {
        children: "ui"
      }), "라는 라이브러리에 종속되어 있고 라이브러리에 ", _jsx(_components.code, {
        children: "build"
      }), " task가 있는 경우, ", _jsx(_components.code, {
        children: "ui"
      }), "의 ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트가 ", _jsx(_components.strong, {
        children: "먼저"
      }), " 실행됩니다. 성공적으로 완료되면 애플리케이션의 ", _jsx(_components.code, {
        children: "build"
      }), " task가 실행됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이는 애플리케이션의 ", _jsx(_components.code, {
        children: "build"
      }), " task가 컴파일하는 데 필요한 모든 필수 종속성을 갖도록 보장하므로 중요한 패턴입니다. 이 개념은 종속성 그래프가 여러 수준의 task 종속성을 가진 더 복잡한 구조로 성장함에 따라 적용됩니다."]
    }), "\n", _jsx(_components.h4, {
      id: "동일한-패키지의-task에-의존하기",
      children: "동일한 패키지의 task에 의존하기"
    }), "\n", _jsxs(_components.p, {
      children: ["때로는 동일한 패키지의 두 task가 특정 순서로 실행되도록 해야 할 수 있습니다. 예를 들어, 동일한 라이브러리에서 ", _jsx(_components.code, {
        children: "test"
      }), " task를 실행하기 전에 라이브러리의 ", _jsx(_components.code, {
        children: "build"
      }), " task를 실행해야 할 수 있습니다. 이렇게 하려면 ", _jsx(_components.code, {
        children: "dependsOn"
      }), " 키에서 스크립트를 일반 문자열로 지정합니다(", _jsx(_components.code, {
        children: "^"
      }), " 없이)."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h4, {
      id: "특정-패키지의-특정-task에-의존하기",
      children: "특정 패키지의 특정 task에 의존하기"
    }), "\n", _jsxs(_components.p, {
      children: ["특정 패키지의 개별 task를 의존하도록 지정할 수도 있습니다. 아래 예제에서는 모든 ", _jsx(_components.code, {
        children: "lint"
      }), " task 전에 ", _jsx(_components.code, {
        children: "utils"
      }), "의 ", _jsx(_components.code, {
        children: "build"
      }), " task를 실행해야 합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"utils#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "의존 task에 대해 더 구체적으로 지정하여 특정 패키지로 제한할 수도 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"web#lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"utils#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 구성을 사용하면 ", _jsx(_components.code, {
        children: "web"
      }), " 패키지의 ", _jsx(_components.code, {
        children: "lint"
      }), " task는 ", _jsx(_components.code, {
        children: "utils"
      }), " 패키지의 ", _jsx(_components.code, {
        children: "build"
      }), " task가 완료된 후에만 실행할 수 있습니다."]
    }), "\n", _jsx(_components.h4, {
      id: "종속성-없음",
      children: "종속성 없음"
    }), "\n", _jsxs(_components.p, {
      children: ["일부 task에는 종속성이 없을 수 있습니다. 예를 들어, Markdown 파일에서 오타를 찾는 task는 다른 task의 상태를 신경 쓸 필요가 없을 것입니다. 이 경우 ", _jsx(_components.code, {
        children: "dependsOn"
      }), " 키를 생략하거나 빈 배열을 제공할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"spell-check\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "outputs-지정하기",
      children: [_jsx(_components.code, {
        children: "outputs"
      }), " 지정하기"]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["Turborepo는 task의 출력을 캐싱하므로 동일한 작업을 두 번 수행하지 않습니다.\n이에 대해서는 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/caching",
          children: "캐싱 가이드"
        }), "에서 자세히\n다루겠지만, 먼저 task가 올바르게 구성되었는지 확인해야 합니다."]
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "outputs"
      }), " 키는 task가 성공적으로 완료되었을 때 캐싱해야 하는 ", _jsx(_components.strong, {
        children: "파일과 디렉토리"
      }), "를 Turborepo에 알려줍니다. ", _jsx(_components.strong, {
        children: "이 키가 정의되지 않으면 Turborepo는 파일을 캐싱하지 않습니다. 후속 실행에서 캐시를 적중해도 파일 출력을 복원하지 않습니다."
      })]
    }), "\n", _jsx(_components.p, {
      children: "다음은 일반적인 도구의 출력 예제입니다:"
    }), "\n", _jsxs(Tabs, {
      items: ["Next.js", "Vite", "tsc"],
      storageKey: "outputs-tools",
      children: [_jsx(Tab, {
        value: "Next.js",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\".next/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"!.next/cache/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "] "
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "Vite",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"dist/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "] "
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "tsc",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"dist/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "] "
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Glob은 패키지에 상대적이므로 ", _jsx(_components.code, {
        children: "dist/**"
      }), "는 각 패키지에 대해 출력되는 ", _jsx(_components.code, {
        children: "dist"
      }), "를 각각 처리합니다. ", _jsx(_components.code, {
        children: "outputs"
      }), " 키에 대한 globbing 패턴 구축에 대한 자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/globs",
        children: "globbing 사양"
      }), "을 참조하세요."]
    }), "\n", _jsxs(_components.h3, {
      id: "inputs-지정하기",
      children: [_jsx(_components.code, {
        children: "inputs"
      }), " 지정하기"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "inputs"
      }), " 키는 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "캐싱"
      }), "을 위해 task의 해시에 포함하려는 파일을 지정하는 데 사용됩니다. 기본적으로 Turborepo는 Git에서 추적하는 패키지의 모든 파일을 포함합니다. 그러나 ", _jsx(_components.code, {
        children: "inputs"
      }), " 키를 사용하여 해시에 포함할 파일을 더 구체적으로 지정할 수 있습니다."]
    }), "\n", _jsx(_components.p, {
      children: "예를 들어, Markdown 파일에서 오타를 찾는 task는 다음과 같이 정의할 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"spell-check\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"**/*.md\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"**/*.mdx\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이제 Markdown 파일의 변경 사항", _jsx(_components.strong, {
        children: "만"
      }), " ", _jsx(_components.code, {
        children: "spell-check"
      }), " task가 캐시를 미스하게 합니다."]
    }), "\n", _jsxs(Callout, {
      type: "error",
      children: [_jsxs(_components.p, {
        children: ["이 기능은 소스 제어에서 추적하는 변경 사항을 따르는 것을 포함하여 Turborepo의 모든 기본 ", _jsx(_components.code, {
          children: "inputs"
        }), " 동작을 거부합니다. 이는 ", _jsx(_components.code, {
          children: ".gitignore"
        }), " 파일이 더 이상 존중되지 않으며, glob으로 해당 파일을 캡처하지 않도록 해야 함을 의미합니다."]
      }), _jsxs(_components.p, {
        children: ["기본 동작을 복원하려면 ", _jsxs(_components.a, {
          href: "#restoring-defaults-with-turbo_default",
          children: [_jsx(_components.code, {
            children: "$TURBO_DEFAULT$"
          }), " 마이크로 구문"]
        }), "을 사용하세요."]
      })]
    }), "\n", _jsxs(_components.h4, {
      id: "turbo_default로-기본값-복원하기",
      children: [_jsx(_components.code, {
        children: "$TURBO_DEFAULT$"
      }), "로 기본값 복원하기"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/configuration#inputs",
        children: ["기본 ", _jsx(_components.code, {
          children: "inputs"
        }), " 동작"]
      }), "은 종종 task에 원하는 것입니다. 그러나 task 출력에 영향을 주지 않는 것으로 알려진 파일의 변경 사항을 무시하도록 ", _jsx(_components.code, {
        children: "inputs"
      }), "를 미세 조정하여 특정 task의 캐시 적중률을 높일 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이러한 이유로 ", _jsx(_components.code, {
        children: "$TURBO_DEFAULT$"
      }), " 마이크로 구문을 사용하여 기본 ", _jsx(_components.code, {
        children: "inputs"
      }), " 동작을 미세 조정할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_DEFAULT$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!README.md\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 task 정의에서 Turborepo는 ", _jsx(_components.code, {
        children: "build"
      }), " task에 대해 기본 ", _jsx(_components.code, {
        children: "inputs"
      }), " 동작을 사용하지만 ", _jsx(_components.code, {
        children: "README.md"
      }), " 파일의 변경 사항은 무시합니다. ", _jsx(_components.code, {
        children: "README.md"
      }), " 파일이 변경되어도 task는 여전히 캐시를 적중합니다."]
    }), "\n", _jsx(_components.h3, {
      id: "root-task-등록하기",
      children: "Root Task 등록하기"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "를 사용하여 Workspace 루트의 ", _jsx(_components.code, {
        children: "package.json"
      }), "에서 스크립트를 실행할 수도 있습니다. 예를 들어, 각 패키지의 ", _jsx(_components.code, {
        children: "lint"
      }), " task 외에도 Workspace 루트 디렉토리의 파일에 대한 ", _jsx(_components.code, {
        children: "lint:root"
      }), " task를 실행할 수 있습니다:"]
    }), "\n", _jsxs(Tabs, {
      items: ["turbo.json", "package.json"],
      children: [_jsx(Tab, {
        value: "turbo.json",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"//#lint:root\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {} "
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "package.json",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run lint lint:root\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint:root\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"eslint .\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Root Task가 등록되면 ", _jsx(_components.code, {
        children: "turbo run lint:root"
      }), "가 task를 실행합니다. 또한 ", _jsx(_components.code, {
        children: "turbo run lint lint:root"
      }), "를 실행하여 모든 린팅 task를 실행할 수 있습니다."]
    }), "\n", _jsx(_components.h4, {
      id: "root-task를-사용하는-경우",
      children: "Root Task를 사용하는 경우"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Workspace 루트의 린팅 및 포맷팅"
        }), ": Workspace 루트에 린팅 및 포맷팅하려는 코드가 있을 수 있습니다. 예를 들어, 루트 디렉토리에서 ESLint 또는 Prettier를 실행할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "점진적 마이그레이션"
        }), ": Turborepo로 마이그레이션하는 동안 아직 패키지로 이동하지 않은 일부 스크립트가 있는 중간 단계가 있을 수 있습니다. 이 경우 Root Task를 생성하여 마이그레이션을 시작하고 나중에 task를 패키지로 분산할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "패키지 범위가 없는 스크립트"
        }), ": 특정 패키지의 컨텍스트에서 의미가 없는 일부 스크립트가 있을 수 있습니다. 이러한 스크립트는 Root Task로 등록할 수 있으므로 캐싱, 병렬화 및 워크플로우 목적으로 여전히 ", _jsx(_components.code, {
          children: "turbo"
        }), "로 실행할 수 있습니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "고급-사용-사례",
      children: "고급 사용 사례"
    }), "\n", _jsx(_components.h3, {
      id: "package-configuration-사용하기",
      children: "Package Configuration 사용하기"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "Package Configuration"
      }), "은 패키지에 직접 배치되는 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 파일입니다. 이를 통해 패키지는 리포지토리의 나머지 부분에 영향을 주지 않고 자체 task에 대한 특정 동작을 정의할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["많은 팀이 있는 대규모 monorepo에서는 팀이 자체 task에 대해 더 큰 제어권을 갖습니다. 자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "Package Configuration 문서"
      }), "를 참조하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "런타임-종속성이-있는-장기-실행-task",
      children: "런타임 종속성이 있는 장기 실행 task"
    }), "\n", _jsxs(_components.p, {
      children: ["동시에 항상 실행되어야 하는 다른 task가 필요한 장기 실행 task가 있을 수 있습니다. 이를 위해 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#with",
        children: [_jsx(_components.code, {
          children: "with"
        }), " 키"]
      }), "를 사용합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"with\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"api#dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["장기 실행 task는 종료되지 않으므로 이에 의존할 수 없습니다. 대신 ", _jsx(_components.code, {
        children: "with"
      }), " 키워드는 ", _jsx(_components.code, {
        children: "web#dev"
      }), " task가 실행될 때마다 ", _jsx(_components.code, {
        children: "api#dev"
      }), " task를 실행합니다."]
    }), "\n", _jsx(_components.h3, {
      id: "부작용-수행하기",
      children: "부작용 수행하기"
    }), "\n", _jsxs(_components.p, {
      children: ["캐시된 빌드 후 배포 스크립트와 같이 일부 task는 항상 실행되어야 합니다. 이러한 task의 경우 task 정의에 ", _jsx(_components.code, {
        children: "\"cache\": false"
      }), "를 추가합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"deploy\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "병렬로-실행할-수-있는-종속-task",
      children: "병렬로 실행할 수 있는 종속 task"
    }), "\n", _jsx(_components.p, {
      children: "일부 task는 다른 패키지에 종속되어 있음에도 불구하고 병렬로 실행할 수 있습니다. 이 설명에 맞는 task의 예는 타입 체커입니다. 타입 체커는 성공적으로 실행하기 위해 종속성의 출력을 기다릴 필요가 없기 때문입니다."
    }), "\n", _jsxs(_components.p, {
      children: ["이 때문에 ", _jsx(_components.code, {
        children: "check-types"
      }), " task를 다음과 같이 정의하고 싶을 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {} "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// Incorrect!"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이렇게 하면 task가 병렬로 실행되지만 종속성의 소스 코드 변경 사항을 고려하지 않습니다. 이는 다음을 의미합니다:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "ui"
        }), " 패키지의 인터페이스에 중단 변경을 합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo check-types"
        }), "를 실행하여 ", _jsx(_components.code, {
          children: "ui"
        }), "에 종속되는 애플리케이션 패키지에서 캐시를 적중합니다."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "애플리케이션 패키지가 새 인터페이스를 사용하도록 업데이트되지 않았음에도 불구하고 성공적인 캐시 적중을 표시하므로 이는 올바르지 않습니다. 편집기에서 애플리케이션 패키지의 TypeScript 오류를 수동으로 확인하면 오류가 나타날 것입니다."
    }), "\n", _jsxs(_components.p, {
      children: ["이 때문에 ", _jsx(_components.code, {
        children: "check-types"
      }), " task 정의를 약간 변경합니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// This works...but could be faster!"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "ui"
      }), " 패키지에서 중단 변경을 다시 테스트하면 캐싱 동작이 이제 올바른 것을 알 수 있습니다. 그러나 task는 더 이상 병렬로 실행되지 않습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["두 요구 사항(정확성과 병렬성)을 모두 충족하려면 Task Graph에 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#transit-nodes",
        children: "Transit Node"
      }), "를 도입할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"transit\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^transit\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"transit\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이러한 Transit Node는 ", _jsx(_components.code, {
        children: "package.json"
      }), "의 스크립트와 일치하지 않아 아무 작업도 수행하지 않는 task를 사용하여 패키지 종속성 간의 관계를 생성합니다. 이 때문에 task는 병렬로 실행", _jsx(_components.strong, {
        children: "되고"
      }), " 내부 종속성의 변경 사항을 인식할 수 있습니다."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["이 예제에서는 ", _jsx(_components.code, {
          children: "transit"
        }), "이라는 이름을 사용했지만 Workspace에서 이미 스크립트가\n아닌 이름을 사용할 수 있습니다."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "다음-단계",
      children: "다음 단계"
    }), "\n", _jsxs(_components.p, {
      children: ["향후 가이드에서 탐색할 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration",
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), " 구성 문서"]
      }), "에서 더 많은 옵션을 사용할 수 있습니다. 지금은 기본 작동 방식을 확인하기 위해 몇 가지 task를 실행할 수 있습니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
